import "antd/lib/menu/style";
import Menu from "antd/lib/menu";

export default Menu;
